import { type ReactNode } from 'react';
import { ItemsTable } from 'receivable-invoices-js/react/components/items-table';
import { QuoteActions } from 'receivable-invoices-js/react/components/quotes/actions';
import { QuoteInformation } from 'receivable-invoices-js/react/components/quotes/information';
import type { Quote } from 'receivable-invoices-js/react/api/models/quote';
import styles from '../responsive-view.module.css';

interface QuoteContentProps {
  document: Quote;
  isMobile: boolean;
  clientPortalId?: string;
  isClientPortalEnabled?: boolean;
}

export function QuoteContent({
  document,
  isMobile,
  clientPortalId,
  isClientPortalEnabled,
}: QuoteContentProps): ReactNode {
  return (
    <div className={styles.details} data-testid="quote-content">
      <QuoteInformation quote={document} />
      {!isMobile ? (
        <QuoteActions
          clientPortalId={clientPortalId}
          data-testid="quote-actions"
          isClientPortalEnabled={isClientPortalEnabled}
          pdfUrl={document.pdfUrl}
        />
      ) : null}
      <ItemsTable
        className={styles.itemsTable}
        data-testid="quote-items-table"
        sections={document.sections}
      />
    </div>
  );
}
